(() => {
  const STORAGE_KEY = 'manualsPreferredLanguage';
  const DOWNLOAD_CLASS = 'is-downloading';

  function safeReadPreferredLanguage() {
    try {
      return (localStorage.getItem(STORAGE_KEY) || '').toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function safeWritePreferredLanguage(code) {
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch (e) {
      // Ignore storage errors.
    }
  }

  function sortCardsByOrder(productElement) {
    const container = productElement.querySelector('[data-manuals-cards]');
    if (!container) return;

    const cards = Array.from(container.querySelectorAll('[data-manual-item]'));
    cards.sort((a, b) => {
      const left = Number(a.dataset.sortOrder || 999);
      const right = Number(b.dataset.sortOrder || 999);
      return left - right;
    });

    cards.forEach((card) => container.appendChild(card));
  }

  function initManuals(root) {
    const nav = root.querySelector('[data-manuals-language-nav]');
    const products = Array.from(root.querySelectorAll('[data-manuals-product]'));
    const cards = Array.from(root.querySelectorAll('[data-manual-item]'));

    if (!nav || cards.length === 0) return;

    products.forEach(sortCardsByOrder);

    const languages = [];
    const seenCodes = new Set();

    cards.forEach((card) => {
      const code = (card.dataset.langCode || '').toLowerCase();
      if (!code || seenCodes.has(code)) return;

      const label = (card.dataset.langLabel || code.toUpperCase()).trim();
      seenCodes.add(code);
      languages.push({ code, label });
    });

    if (languages.length === 0) return;

    nav.innerHTML = languages
      .map(
        (language) =>
          `<button type="button" class="manuals-downloads__language-btn" data-language-button="${language.code}">${language.label}</button>`
      )
      .join('');

    const buttons = Array.from(nav.querySelectorAll('[data-language-button]'));
    const preferredFromStorage = safeReadPreferredLanguage();
    const preferredFromLocale = (root.dataset.defaultLanguage || '').slice(0, 2).toLowerCase();

    let activeCode = languages[0].code;

    if (languages.some((language) => language.code === preferredFromStorage)) {
      activeCode = preferredFromStorage;
    } else if (languages.some((language) => language.code === preferredFromLocale)) {
      activeCode = preferredFromLocale;
    }

    function renderByLanguage(code) {
      buttons.forEach((button) => {
        const isActive = button.dataset.languageButton === code;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      products.forEach((product) => {
        const productCards = Array.from(product.querySelectorAll('[data-manual-item]'));
        let visibleCount = 0;

        productCards.forEach((card) => {
          const show = (card.dataset.langCode || '').toLowerCase() === code;
          card.classList.toggle('is-hidden', !show);
          if (show) visibleCount += 1;
        });

        const empty = product.querySelector('[data-no-results]');
        if (empty) {
          empty.classList.toggle('is-hidden', visibleCount > 0);
        }
      });

      safeWritePreferredLanguage(code);
    }

    root.addEventListener('click', async (event) => {
      const downloadLink = event.target.closest('[data-manual-download]');
      if (!downloadLink || !root.contains(downloadLink)) return;

      const fileUrl = downloadLink.getAttribute('href');
      if (!fileUrl) return;

      event.preventDefault();

      if (downloadLink.dataset.downloading === 'true') return;
      downloadLink.dataset.downloading = 'true';
      downloadLink.classList.add(DOWNLOAD_CLASS);
      downloadLink.setAttribute('aria-busy', 'true');

      const fileName = (downloadLink.dataset.manualFilename || 'manual.pdf').trim();

      try {
        const response = await fetch(fileUrl, { mode: 'cors', credentials: 'omit' });
        if (!response.ok) throw new Error(`Download failed with status ${response.status}`);

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const tempLink = document.createElement('a');
        tempLink.href = blobUrl;
        tempLink.download = fileName;
        tempLink.style.display = 'none';
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);

        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
      } catch (error) {
        window.location.href = fileUrl;
      } finally {
        downloadLink.dataset.downloading = 'false';
        downloadLink.classList.remove(DOWNLOAD_CLASS);
        downloadLink.removeAttribute('aria-busy');
      }
    });

    nav.addEventListener('click', (event) => {
      const target = event.target.closest('[data-language-button]');
      if (!target) return;
      renderByLanguage(target.dataset.languageButton);
    });

    renderByLanguage(activeCode);
  }

  document.querySelectorAll('[data-manuals-downloads]').forEach(initManuals);
})();
